var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ViewerScriptFlowAPI } from '../flow-api/ViewerScript';
import { getPlatformApi } from '../platformApi';
import { getAppData, setAppData, setViewerScriptFlowAPI, setViewerScriptFlowAPIInitPromise, } from './sharableInstances';
export var initAppForPageWrapper = function (_a) {
    var initAppForPage = _a.initAppForPage, _b = _a.sentryConfig, sentryConfig = _b === void 0 ? null : _b, _c = _a.experimentsConfig, experimentsConfig = _c === void 0 ? null : _c, _d = _a.inEditor, inEditor = _d === void 0 ? false : _d, projectName = _a.projectName, defaultTranslations = _a.defaultTranslations, translationsConfig = _a.translationsConfig, biConfig = _a.biConfig, biLogger = _a.biLogger, _e = _a.appName, appName = _e === void 0 ? null : _e, optionalDeps = _a.optionalDeps, localeDistPath = _a.localeDistPath, prepopulatedData = _a.prepopulatedData, shouldUseEssentials = _a.shouldUseEssentials;
    return function (initParams, platformAPIs, namespaces, platformServices) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, userAPI, windowAPI, siteAPI, seoAPI, viewerScriptFlowAPI, viewerScriptFlowAPIInitPromise, appData, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getPlatformApi(platformAPIs.platformApiProvider)];
                case 1:
                    _a = _b.sent(), userAPI = _a.userAPI, windowAPI = _a.windowAPI, siteAPI = _a.siteAPI, seoAPI = _a.seoAPI;
                    viewerScriptFlowAPI = new ViewerScriptFlowAPI({
                        experimentsConfig: experimentsConfig,
                        projectName: projectName,
                        sentryConfig: sentryConfig,
                        platformBI: platformServices.bi,
                        biLoggerFactory: platformServices.biLoggerFactory,
                        essentials: platformServices.essentials,
                        monitoring: platformServices.monitoring,
                        userAPI: userAPI,
                        windowAPI: windowAPI,
                        siteAPI: siteAPI,
                        seoAPI: seoAPI,
                        appData: initParams,
                        translationsConfig: translationsConfig,
                        defaultTranslations: defaultTranslations,
                        inEditor: inEditor,
                        biConfig: biConfig,
                        biLogger: biLogger,
                        appName: appName,
                        optionalDeps: optionalDeps,
                        localeDistPath: localeDistPath,
                        prepopulatedData: prepopulatedData,
                        shouldUseEssentials: shouldUseEssentials,
                    });
                    setViewerScriptFlowAPI(viewerScriptFlowAPI);
                    viewerScriptFlowAPIInitPromise = viewerScriptFlowAPI.init();
                    setViewerScriptFlowAPIInitPromise(viewerScriptFlowAPIInitPromise);
                    return [4 /*yield*/, viewerScriptFlowAPIInitPromise];
                case 2:
                    _b.sent();
                    if (!initAppForPage) return [3 /*break*/, 6];
                    _b.label = 3;
                case 3:
                    _b.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, initAppForPage(initParams, platformAPIs, namespaces, platformServices, viewerScriptFlowAPI)];
                case 4:
                    appData = _b.sent();
                    setAppData(appData);
                    return [3 /*break*/, 6];
                case 5:
                    e_1 = _b.sent();
                    if (!inEditor) {
                        // Currently platform doesn't log errors happened in worker. We want to fix it here.
                        console.error("\u2757\uFE0FError \uD83D\uDC49 \"".concat(appName, "\" app \uD83D\uDC49 `viewer.app.ts` module \u2757\n"), e_1);
                        viewerScriptFlowAPI.reportError(e_1);
                    }
                    throw e_1;
                case 6: 
                // appData will be available in controllers
                return [2 /*return*/, getAppData()];
            }
        });
    }); };
};
//# sourceMappingURL=viewerAppWrapper.js.map